import { IEditorText } from "./EditorDefinitions";
import { EditorRawStateHelper } from "./EditorModelHelper";

export class EditorTextHelper {
  static toHtml(notes: IEditorText | undefined): string {
    if (notes?.type === "raw")
      return EditorRawStateHelper.rawToHtml(notes.value);
    if (notes?.type === "html")
      return notes.value;
    return "";
  }

  static isEmpty(notes: IEditorText | undefined): boolean {
    if (!notes)
      return true;
    if (notes.type === "raw")
      return EditorRawStateHelper.isEmpty(notes.value);
    if (notes.type === "html")
      return !notes.value;
    return true;
  }
}